/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Output_Locale_SelectInputs */

const en_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output Locale Select`)
};

const fr_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélection de la locale de sortie`)
};

const de_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgabegebietsschema auswählen`)
};

const it_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selezione locale di output`)
};

const ru_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выбор локали вывода`)
};

const es_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selección de configuración regional de salida`)
};

const zh_cn2_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出区域选择`)
};

const ja_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出力ロケールの選択`)
};

const hi_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आउटपुट लोकेल चयन`)
};

const pt_pt2_output_locale_select = /** @type {(inputs: Output_Locale_SelectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleção de localidade de saída`)
};

/**
* | output |
* | --- |
* | "Output Locale Select" |
*
* @param {Output_Locale_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const output_locale_select = /** @type {((inputs?: Output_Locale_SelectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Output_Locale_SelectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_output_locale_select(inputs)
	if (locale === "de") return de_output_locale_select(inputs)
	if (locale === "it") return it_output_locale_select(inputs)
	if (locale === "ru") return ru_output_locale_select(inputs)
	if (locale === "es") return es_output_locale_select(inputs)
	if (locale === "zh-CN") return zh_cn2_output_locale_select(inputs)
	if (locale === "ja") return ja_output_locale_select(inputs)
	if (locale === "hi") return hi_output_locale_select(inputs)
	if (locale === "pt-PT") return pt_pt2_output_locale_select(inputs)
	return en_output_locale_select(inputs)
});